
import initIndex from './utilities/algoliaInitIndex'

const brandsIndex = initIndex('brands')

const algoliaSearchBrand =
	query => brandsIndex.search({
		query,
		hitsPerPage: 24,
		page: 0
	}).catch((error) => { //  TODO: Add to error types/messages
		console.log('ALGOLIA ERROR', error)
		return { error, query }
	})

export default algoliaSearchBrand



// WEBPACK FOOTER //
// ./src/dataservices/algoliaSearchBrand.js